(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autohaul-brand-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('autohaul-carousel-motion')) {
  customElements.define('autohaul-carousel-motion', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.autohaul-brand-carousel__track');
      this.viewport = this.querySelector('.autohaul-brand-carousel__viewport');
      if (!this.track || !this.viewport) return;
      this.events = new AbortController();
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.direction = 1;
      this.speed = Number(this.dataset.speed) || 16;
      const signal = this.events.signal;
      this.addEventListener('pointerdown', (event) => {
        this.pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        this.pointerIntent = null;
        this.pointerActive = true;
        this.pause();
      }, { capture: true, signal });
      document.addEventListener('pointermove', (event) => {
        if (!this.pointerActive || !this.pointerStart || event.pointerId !== this.pointerStart.id || this.pointerIntent) return;
        const x = Math.abs(event.clientX - this.pointerStart.x);
        const y = Math.abs(event.clientY - this.pointerStart.y);
        if (Math.max(x, y) < 8) return;
        this.pointerIntent = y > x ? 'vertical' : 'horizontal';
        if (this.pointerIntent === 'vertical') {
          this.pointerActive = false;
          this.schedule();
        }
      }, { passive: true, signal });
      for (const eventName of ['pointerup', 'pointercancel']) {
        document.addEventListener(eventName, (event) => {
          if (event.pointerId !== this.pointerStart?.id) return;
          this.pointerStart = null;
          if (!this.pointerActive) return;
          this.pointerActive = false;
          if (eventName === 'pointerup' || this.pointerIntent === 'horizontal') this.interact();
          else this.schedule();
        }, { signal });
      }
      this.addEventListener('wheel', (event) => {
        if (event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) this.interact();
      }, { capture: true, passive: true, signal });
      this.viewport.addEventListener('scroll', () => {

        if (!this.frame) this.schedule();
      }, { passive: true, signal });
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.pause();
      }, { signal });
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.schedule();
      }, { signal });
      this.addEventListener('focusin', (event) => {
        this.keyboardFocus = event.target.matches(':focus-visible');
        this.interact();
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.keyboardFocus = false;
          this.schedule();
        }
      }, { signal });
      this.addEventListener('keydown', () => {
        this.keyboardFocus = true;
        this.interact();
      }, { capture: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.schedule();
      }, { signal });
      this.motionQuery.addEventListener('change', () => {
        this.pause();
        this.schedule();
      }, { signal });
      this.resize = new ResizeObserver(() => {
        this.pause();

        this.schedule();
      });
      this.resize.observe(this.viewport);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.schedule();
        else this.pause();
      }, { threshold: 0 });
      this.observer.observe(this.viewport);

    }

    interact() {
      this.hasInteracted = true;
      const configuredDelay = Number(this.dataset.resumeDelay);
      const delay = Number.isFinite(configuredDelay) ? Math.max(0, configuredDelay) : 4;
      this.resumeAt = Date.now() + delay * 1000;
      this.pause();
      this.schedule();
    }

    schedule() {
      clearTimeout(this.resumeTimer);
      if (this.dataset.autoplay !== 'true' || this.motionQuery.matches || this.hovered || this.keyboardFocus || this.pointerActive || !this.inView || document.hidden) return;
      if (this.initialStartAt === undefined) {
        const configuredDelay = Number(this.dataset.startDelay);
        this.initialStartAt = Date.now() + (Number.isFinite(configuredDelay) ? Math.max(0, configuredDelay) : 0) * 1000;
      }
      const readyAt = this.hasInteracted ? this.resumeAt : this.hasStarted ? 0 : this.initialStartAt;
      const delay = Math.max(0, readyAt - Date.now());
      if (delay === 0) {
        this.start();
        return;
      }
      this.resumeTimer = setTimeout(() => this.start(), delay);
    }

    start() {
      if (this.frame || this.hovered || this.keyboardFocus || this.pointerActive || !this.inView || document.hidden || this.motionQuery.matches) return;
      if (this.dataset.autoplay !== 'true' || this.track.scrollWidth <= this.viewport.clientWidth) return;
      this.hasStarted = true;
      this.position = this.viewport.scrollLeft;
      this.classList.add('is-auto-moving');
      this.track.style.transform = 'translate3d(0,0,0)';
      this.previousTime = null;
      const tick = (time) => {
        const elapsed = this.previousTime === null ? 0 : Math.min((time - this.previousTime) / 1000, 0.05);
        this.previousTime = time;
        const maximum = this.track.scrollWidth - this.viewport.clientWidth;
        this.position = Math.max(0, Math.min(maximum, this.position + this.direction * this.speed * elapsed));
        this.viewport.scrollLeft = this.position;
        const fractionalOffset = this.viewport.scrollLeft - this.position;
        this.track.style.transform = 'translate3d(' + fractionalOffset + 'px,0,0)';
        if (this.position >= maximum) this.direction = -1;
        else if (this.position <= 0) this.direction = 1;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    pause() {
      clearTimeout(this.resumeTimer);
      if (!this.frame) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.track.style.transform = '';
      this.viewport.scrollTo({ left: this.position, behavior: 'instant' });
      this.classList.remove('is-auto-moving');

    }

    disconnectedCallback() {
      this.pause();
      clearTimeout(this.resumeTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autohaul-footer-prototype"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('autohaul-footer-preview')) {
  customElements.define('autohaul-footer-preview', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.resize = () => this.querySelectorAll('details').forEach(details => { details.open = !this.media.matches; });
      this.resize();
      this.menuClick = (event) => {
        const trigger = event.target.closest('[data-ah-open-header-menu]');
        if (trigger) document.dispatchEvent(new CustomEvent('autohaul:open-categories', { detail: { trigger } }));
      };
      this.addEventListener('click', this.menuClick);
      this.media.addEventListener('change', this.resize);
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.resize); this.removeEventListener('click', this.menuClick); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      document.body.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      document.body.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      document.body.classList.remove('shopify-section-header-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
